<div
  class="flex flex-col bg-white items-center rounded-lg overflow-hidden"
  *transloco="let t"
>
  <div class="flex flex-col w-full items-center space-y-3 mb-2">
    <div class="flex flex-col w-full relative">
      <svc-user-avatar
        class="w-full"
        [style.height.px]="150"
        [info]="userAvatar"
      />
      <div class="text-white uppercase font-bold text-center text-base absolute bottom-0 py-2 w-full bg-gradient-to-t from-gray-900 w-[196px] left-1/2 -translate-x-1/2 whitespace-normal break-all leading-tight px-1">
        {{ user?.firstLastName }}
      </div>
    </div>

    <div class="flex flex-col">
      <div class="text-black text-center text-base">
        {{ user?.employeePositionName }}
      </div>
      <div class="text-black text-center text-base">
        {{ user?.areaName }}
      </div>
    </div>
  </div>

  @if (indicators) {
    <div class="flex flex-row flex-wrap w-full justify-center">
      @for (indicator of indicators; track indicator) {
        @if (indicator.show) {
          <div
            class="flex flex-col px-0.5 mb-3 items-center"
            [ngClass]="{ 'w-1/2': indicators.length <= 2, 'w-1/4': indicators.length > 2 }"
          >
            <span
              class="flex-auto block text-center text-xxs text-black"
              [style.wordWrap]="'break-word'"
              [style.wordBreak]="'break-word'"
            >
              {{ t(indicator.description) }}
            </span>

            @if (!indicator.error && !indicator.loading) {
              <span class="items-center text-center text-base font-bold text-black">
                {{ indicator?.amount | formatNumberDefault }}
              </span>
            }

            @if (!indicator.error && indicator.loading) {
              <div class="pt-1">
                <ngx-skeleton-loader
                  appearance="line"
                  [theme]="{ width: '32px', height: '24px' }">
                </ngx-skeleton-loader>
              </div>
            }

            @if (indicator.error) {
              <div class="pt-1">
                <mat-icon
                  class="icon-size-4 text-default"
                  svgIcon="heroicons_solid:exclamation-triangle"
                ></mat-icon>
              </div>
            }
          </div>
        }
      }
    </div>
  }

  <svc-location-active class="mt-3 w-full px-3"></svc-location-active>
</div>
